import React from 'react';
import classnames from 'classnames';

const className = "cursor-pointer bg-gray-400 p-3 px-6 text-gray-800 font-semibold rounded-full";

const SecondaryButton = props => (
    <button {...props} className={classnames(className, props.className)}>{props.children}</button>
);

export default SecondaryButton;